const productionConstants = {
    apiUrl: 'https://testerly.com/api',
}

const developmentConstants = {
    apiUrl: 'http://127.0.0.1:8000/api',
}
export const constants = process.env.NODE_ENV === 'development' ? developmentConstants : productionConstants;